var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.25 9.58333C40.25 8.56667 39.8461 7.59165 39.1272 6.87276C38.4084 6.15387 37.4333 5.75 36.4167 5.75H9.58333C8.56667 5.75 7.59165 6.15387 6.87276 6.87276C6.15387 7.59165 5.75 8.56667 5.75 9.58333V36.4167C5.75 37.4333 6.15387 38.4084 6.87276 39.1272C7.59165 39.8461 8.56667 40.25 9.58333 40.25H36.4167C37.4333 40.25 38.4084 39.8461 39.1272 39.1272C39.8461 38.4084 40.25 37.4333 40.25 36.4167V9.58333ZM31.0634 28.3533L28.3533 31.0634L23 25.7102L17.6467 31.0634L14.9366 28.3533L20.2898 23L14.9366 17.6467L17.6467 14.9366L23 20.2898L28.3533 14.9366L31.0634 17.6467L25.7102 23L31.0634 28.3533Z",
    fill: "#FF6161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXSquare);
export default __webpack_public_path__ + "static/media/x-square.6fcafc87a76c3520ef4ed22836320d63.svg";
export { ForwardRef as ReactComponent };